import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';
import { OutputModel, MappingOutputAttribute, MappingOutputAttributeModel } from '../model/classes/output.classes';
import { OutputPushResponse, OutputPushModel, OutputResultDocument } from '../model/interfaces/output.interface';

@Injectable()
export class OutputService {
    private outputUrl = 'api/output';

    constructor(private sxHttp: SxHttpService) { }

    getList(systemCode: string): Observable<TemplateListadoItem[]> {
        return this.sxHttp.get(this.outputUrl + '/' + systemCode).map(response => {
            const outputs = response.json().data;
            return outputs.map(output => {
                return {
                    id: output.outputCode,
                    imagen: output.urlImage,
                    titulo: output.outputCode,
                    subtitulo: output.description,
                };
            });
        });
    }

    get(systemCode: string, outputCode: string): Observable<OutputModel> {
        return this.sxHttp
            .get(this.outputUrl + '/' + systemCode + '/' + outputCode)
            .map(response => response.json().data as OutputModel);
    }
    getJobStatus(systemCode: string, outputCode: string): Observable<boolean> {
        return this.sxHttp
            .get(this.outputUrl + '/' + systemCode + '/' + outputCode + '/' + 'GetJobStatus')
            .map(response => response.json().data );
    }
    create(output: OutputModel): Promise<OutputModel> {
        return this.sxHttp
            .post(this.outputUrl, output)
            .toPromise()
            .then(response => response.json().data as OutputModel);
    }

    edit(outputCode, systemCode, output: OutputModel): Promise<OutputModel> {
        delete output['completeness'];
        return this.sxHttp
            .put(
                this.outputUrl + '/' + systemCode + '/' + outputCode,
                output
            )
            .toPromise()
            .then(response => response.json().data as OutputModel);
    }

    scanMappingAttributes(outputCode: string,
        systemCode: string,
        rangeFrom: string,
        rangeTo: string): Observable<MappingOutputAttribute[]> {
        const url = this.outputUrl + `/ScanMappingAttributes/${systemCode}/${outputCode}/${rangeFrom}/${rangeTo}`;
        return this.sxHttp.get(url).map(response => response.json().data as MappingOutputAttribute[]);
    }

    getDocumentsById(id: number) {
        const url = `${this.outputUrl}/Documents/${id}`;
        return this.sxHttp.get(url)
            .map(response => response.json().data as OutputResultDocument[]);
    }

    renewJob(systemCode: string, outputResultId: number) {
        const url = `${this.outputUrl}/Renew/${systemCode}/${outputResultId}`;
        // Should be patch
        return this.sxHttp.get(url)
            .toPromise();
    }

    delete(outputCode: string, systemCode: string): Observable<any> {
        return this.sxHttp
            .delete(this.outputUrl + '/' + systemCode + '/' + outputCode)
            .map(result => result.json().data);
    }
    StopScheduler(outputCode: string, systemCode: string): Observable<any> {
        return this.sxHttp
            .delete(this.outputUrl + '/' + systemCode + '/' + outputCode+ '/' + 'StopScheduler')
            .map(result => result.json().data);
    }
    deleteAttribute(attribute: MappingOutputAttribute): Promise<Boolean> {
        const url = this.outputUrl + `/${attribute.systemCode}/${attribute.outputCode}/attribute/${attribute.id}`;
        return this.sxHttp
            .delete(url)
            .toPromise()
            .then(response => response.json().data as Boolean);
    }

    getOutputAttributes(systemCode: string, outputCode: string): Observable<MappingOutputAttributeModel[]> {
        const url = this.outputUrl + `/${systemCode}/${outputCode}/attribute`;
        return this.sxHttp.get(url).map(response => response.json().data as MappingOutputAttributeModel[]);
    }

    getAttribute(systemCode: string, outputCode: string, mappingId: string): Observable<MappingOutputAttributeModel> {
        const url = this.outputUrl + `/${systemCode}/${outputCode}/attribute/${mappingId}`;
        return this.sxHttp.get(url).map(response => response.json().data as MappingOutputAttributeModel);
    }

    saveAttribute(attribute: MappingOutputAttribute): Promise<MappingOutputAttributeModel> {
        const url = `${this.outputUrl}/attribute`;
        return this.sxHttp
            .post(url, attribute)
            .toPromise()
            .then(response => response.json().data as MappingOutputAttributeModel);
    }

    getCurrentServerTime(): Observable<Date> {
        const url = `${this.outputUrl}/current-date`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data as Date);
    }

    sendPush(model: OutputPushModel): Promise<OutputPushResponse>{
        const url = `${this.outputUrl}/PushOutput`;
        return this.sxHttp
        .post(url, model)
        .toPromise()
        .then(response => response.json().data as OutputPushResponse);
    }

    getPushableDocuments(model: OutputPushModel): Promise<Boolean>{
        const url = `${this.outputUrl}/GetPushableDocuments`;
        return this.sxHttp
        .post(url, model)
        .toPromise()
        .then(response => response.json().data as Boolean);
    }

    getNextExecution(systemCode: string, outputCode: string): Observable<string>{
        const url = `${this.outputUrl}/GetNextExecution/${systemCode}/${outputCode}`;
        return this.sxHttp
            .get(url)
            .map(response => response.json().data as string);
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/output.service.ts